import Splide from "../../../node_modules/@splidejs/splide";


export function initBlockCustomerReviews() {
    [...document.querySelectorAll(".splide.customer-reviews:not(.-initialized)")].map((el) => new ComponentSplideCustomerReviews(el));
}

export class ComponentSplideCustomerReviews {

    _dom = {
        slider: null,
    };

    _splide = null

    constructor(el) {
        if (!el) return;

        this._dom.slider = el;
        this._dom.bar    = el.querySelector( '.splide__progress--bar' );

        this._splide = new Splide(el, {
            type: 'slider',
            perPage: '3',
            gap: '3.2rem',
            pagination: false,
            arrowPath: 'M30.07 22.59L16.33 36.33L20 40L40 20L20 0L16.33 3.67L30.07 17.41L0 17.41L0 22.59L30.07 22.59z',
            breakpoints: {
                1023: {
                    perPage: '2',
                },
                767: {
                    perPage: '1',
                    gap: '2.4rem',
                    padding: {
                        right: '3.2rem',
                    }
                },
            },
            classes: {
                arrows: 'splide__arrows demo',
                arrow : 'splide__arrow demo',
                prev  : 'splide__arrow--prev  demo demo-arrow_left-1',
                next  : 'splide__arrow--next demo demo-arrow_left-1',
            },

        }).mount()

        if(this._dom.bar){
            this._progress();
        }
        this._initListeners();
    }

    _progress = () => {
        this._dom.end  = this._splide.Components.Controller.getEnd() + 1;
        this._dom.rate = Math.min( ( this._splide.index + 1 ) / this._dom.end, 1 );
        this._dom.bar.style.width = String( 100 * this._dom.rate ) + '%';
    }

    _initListeners() {
        // Updates the bar width whenever the carousel moves:
        if(this._dom.bar){
            this._splide.on('mounted move', this._onMountedMove);
        }
    }

    _onMountedMove = () => {
        this._progress();
    }
}